import { useParams, useSearchParams } from 'react-router-dom'
import { validate as uuidValidate } from 'uuid'

export const SESSION_ID_PARAM = 'sessionId'

export const sessionIdsQuery = (sessionIds: string[]): string =>
  sessionIds
    .map((id) => `${SESSION_ID_PARAM}=${encodeURIComponent(id)}`)
    .join('&')

export const isValidSessionId = (sessionId: string): boolean =>
  uuidValidate(sessionId)

export const sessionIdsIn = (
  searchParams: URLSearchParams,
  pathSessionId: string | undefined
): string[] => [
  ...searchParams.getAll(SESSION_ID_PARAM),
  ...(pathSessionId ? [pathSessionId] : []),
]

export const useSessionIdsFromUrl = (): string[] => {
  const [searchParams] = useSearchParams()
  const { sessionId } = useParams<{ sessionId?: string }>()
  return sessionIdsIn(searchParams, sessionId)
}
